module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "copyright"
    }
  }, [_c('p', [_vm._v("Original text © 2013 by Minna Murra, Inc."), _c('br'), _vm._v("Illustrations © 2013 by Pamela Dalton.")]), _vm._v(" "), _c('p', [_vm._v("Acknowledgments of permission to reprint previously published materials appear on "), _c('span', {
    attrs: {
      "href": "#/xhtml/13index#page_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 53")]), _vm._v(", which constitutes as an extension of this copyright page.")]), _vm._v(" "), _c('p', [_vm._v("All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.")]), _vm._v(" "), _c('p', [_vm._v("ISBN 978-1-4521-2963-1"), _c('br'), _vm._v("The Library of Congress has cataloged the previous edition as follows:"), _c('br'), _vm._v("ISBN 978-1-4521-1339-5")]), _vm._v(" "), _c('p', [_vm._v("Design by Amelia May Mack."), _c('br'), _vm._v("Calligraphy by Anne Robin."), _c('br'), _vm._v("Photographs by Matthew Carden."), _c('br'), _vm._v("Typeset in Hoefler & Frere-Jones Requiem.")]), _vm._v(" "), _c('p', [_vm._v("Handprint Books is an imprint of"), _c('br'), _vm._v("Chronicle Books LLC"), _c('br'), _vm._v("680 Second Street"), _c('br'), _vm._v("San Francisco, CA 94107"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.chroniclebooks.com/titles/kids-teens",
      "target": "_blank"
    }
  }, [_vm._v("www.chroniclekids.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eae4b8da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06copyright.vue
// module id = 72
// module chunks = 0